import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createBlock(_component_oss_dialog, {
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dialog) = $event)),
    title: _ctx.tagDialogTitle,
    validLoading: _ctx.tagLoading,
    onValid: _cache[7] || (_cache[7] = ($event: any) => (_ctx.upsertTag())),
    onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.resetTag())),
    validDisabled: _ctx.validDisabled(),
    width: "50vw"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_tabs, {
        modelValue: _ctx.tabStep,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tabStep) = $event)),
        "fixed-tabs": "",
        style: {"background-color":"transparent !important","border-radius":"8px","overflow":"hidden"}
      }, {
        default: _withCtx(() => [
          (_ctx.showTabs)
            ? (_openBlock(), _createBlock(_component_v_tab, {
                key: 0,
                value: "0",
                href: "#0"
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createElementVNode("strong", null, "Description", -1)
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.showTabs)
            ? (_openBlock(), _createBlock(_component_v_tab, {
                key: 1,
                value: "1",
                href: "#1"
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createElementVNode("strong", null, "Produits", -1)
                ])),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_tabs_window, {
        modelValue: _ctx.tabStep,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tabStep) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tabs_window_item, { value: "0" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { class: "mx-4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      (!_ctx.isTagDistribution)
                        ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                            key: 0,
                            modelValue: _ctx.currentTag.name,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentTag.name) = $event)),
                            outlined: "",
                            label: "Nom",
                            "hide-details": "",
                            dense: "",
                            class: "my-3"
                          }, null, 8, ["modelValue"]))
                        : (_openBlock(), _createElementBlock("strong", _hoisted_1, _toDisplayString(_ctx.currentTagName), 1)),
                      (_ctx.currentTag.primaryLog)
                        ? (_openBlock(), _createBlock(_component_v_select_filled, {
                            key: 2,
                            modelValue: _ctx.currentTag.primaryLog,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentTag.primaryLog) = $event)),
                            items: _ctx.primaryLogs,
                            "item-title": _ctx.logTitle,
                            dense: "",
                            outlined: "",
                            class: "mt-2"
                          }, null, 8, ["modelValue", "items", "item-title"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.isTagDistribution && _ctx.currentTag.percentageTags)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_v_row, { class: "mx-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "8" }, {
                          default: _withCtx(() => _cache[11] || (_cache[11] = [
                            _createElementVNode("strong", null, "Etiquette", -1)
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "4" }, {
                          default: _withCtx(() => _cache[12] || (_cache[12] = [
                            _createElementVNode("strong", null, "Pourcentage", -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentTag.percentageTags, (tag, index) => {
                      return (_openBlock(), _createBlock(_component_v_row, {
                        key: index,
                        class: "mx-4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "8" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tag.name), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_oss_text_field_filled, {
                                modelValue: _ctx.currentTag.percentages[index],
                                "onUpdate:modelValue": ($event: any) => ((_ctx.currentTag.percentages[index]) = $event),
                                "hide-details": "",
                                min: 0,
                                max: 1
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                    _createVNode(_component_v_row, { class: "mx-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "8",
                          class: "d-flex justify-end"
                        }, {
                          default: _withCtx(() => _cache[13] || (_cache[13] = [
                            _createElementVNode("strong", null, "Total", -1)
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "4" }, {
                          default: _withCtx(() => [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.percentageTotal), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_tabs_window_item, { value: "1" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { class: "mx-4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select_filled, {
                        modelValue: _ctx.currentTag.invoiceProductType,
                        "onUpdate:modelValue": [
                          _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentTag.invoiceProductType) = $event)),
                          _cache[4] || (_cache[4] = ($event: any) => (_ctx.computeResourceAllocations()))
                        ],
                        items: _ctx.productTypes,
                        "hide-details": "",
                        outlined: "",
                        density: "compact",
                        style: {"pointer-events":"auto"},
                        label: "Type de produit",
                        "item-title": "description",
                        "item-value": "value",
                        class: "my-3 v-select-font-size"
                      }, null, 8, ["modelValue", "items"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.showAllocations)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "mx-3 py-1 align-center justify-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "2" }, {
                          default: _withCtx(() => _cache[14] || (_cache[14] = [
                            _createTextVNode(" Activer ")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "4" }, {
                          default: _withCtx(() => _cache[15] || (_cache[15] = [
                            _createTextVNode(" Affectation ")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "5",
                          class: "pl-2"
                        }, {
                          default: _withCtx(() => _cache[16] || (_cache[16] = [
                            _createTextVNode(" Pourcentage ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "pb-1 align-center justify-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "11" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_divider)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.resourceDistributions.length > 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resourceDistributions, (item, i) => {
                            return (_openBlock(), _createBlock(_component_v_row, {
                              "no-gutters": "",
                              class: "mx-3 pb-1 align-center justify-center",
                              key: i
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "2" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_switch, {
                                      "hide-details": "",
                                      density: "compact",
                                      modelValue: item.active,
                                      "onUpdate:modelValue": ($event: any) => ((item.active) = $event),
                                      class: "pl-2 mt-0",
                                      onChange: ($event: any) => (item.percentage = 0)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_col, { cols: "4" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_col, { cols: "5" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_oss_text_field_filled, {
                                      "hide-details": true,
                                      suffix: "%",
                                      disabled: !item.active,
                                      class: "ml-2 righted-input",
                                      modelValue: item.percentage,
                                      "onUpdate:modelValue": ($event: any) => ((item.percentage) = $event),
                                      rules: _ctx.percentageRules(i)
                                    }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "rules"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128)),
                          _createVNode(_component_v_row, { class: "mx-1 justify-center" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "7",
                                class: "d-flex justify-end"
                              }, {
                                default: _withCtx(() => _cache[17] || (_cache[17] = [
                                  _createElementVNode("strong", null, "Total", -1)
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "4",
                                class: "d-flex justify-end"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("strong", {
                                    style: _normalizeStyle('color:' + (_ctx.totalPercentage() > 100 ? 'red' : 'black'))
                                  }, _toDisplayString(_ctx.totalPercentage() + " %"), 5)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ], 64))
                      : (_openBlock(), _createBlock(_component_v_row, {
                          key: 1,
                          class: "ma-3 justify-center"
                        }, {
                          default: _withCtx(() => _cache[18] || (_cache[18] = [
                            _createTextVNode(" Il n'y a pas de ressources associées à ce type d'étiquette ")
                          ])),
                          _: 1
                        }))
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["modelValue", "title", "validLoading", "validDisabled"]))
}